import axios, { AxiosResponse } from 'axios';
import { getCloudRunServiceUrl } from './axios';

export interface ClearCacheRequest {
  domain: string;
}

export interface ClearCacheResponse {
  success: boolean;
  message?: string;
}

export const tenantConfigApi = {
  /**
   * Clear cached branding data for a tenant's domain
   * @param domain - The primary domain of the tenant
   * @returns Promise with the clear cache result
   */
  clearCache: async (domain: string): Promise<AxiosResponse<ClearCacheResponse>> => {
    return axios.post<ClearCacheResponse>(
      `${getCloudRunServiceUrl('tenant-config')}/clear-cache`,
      { domain } as ClearCacheRequest,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  },
};
